export class PaginationResEntity<T> {
  Data: Array<T> = [];
  data: Array<T> = [];
  Total = 0;
}
